import React, { useEffect, useState } from "react";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { AdminService } from "../../../app/service/admin.service";
import { UserService } from "../../../app/service/user.service";
import { toast } from "react-toastify";
import moment from "moment";
import projectImg from "../../../assets/images/user_cerificates/projects.jpg";

const UserInternships = () => {
  const userdata = sessionStorage.getItem("loginData");
  const userRole = JSON.parse(userdata || "{}");

  const [projectsData, setProjectsData] = useState<any>({});
  const [percentageData, setPercentageData] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});
  const [projectUpload, setProjectUpload] = useState<File | null>(null);
  const [githubLink, setGithubLink] = useState("");
  const [introduction, setIntroduction] = useState("");

  useEffect(() => {
    getProjects();
    getBatchPercentage();
  }, []);

  const getProjects = () => {
    const payload = {
      batchName: userRole?.userBatchName,
    };

    AdminService.getProjectByBatch(payload)
      .then((res: any) => {
        if (res.status === "Success") {
          setProjectsData(res.data);
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getByProjects();
  }, []);

  const getByProjects = () => {
    const payload = {
      email: userRole?.email,
    };

    AdminService.getProjectByEmail(payload)
      .then((res: any) => {
        if (res.status === "Success") {
          setData(res.data);
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const getBatchPercentage = () => {
    const payload = {
      batchName: userRole?.userBatchName,
    };

    UserService.getPercentageByBatch(payload)
      .then((res: any) => {
        if (res.status === "Success") {
          setPercentageData(res.data);
          getByProjects();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (!projectUpload) {
      toast.error("Please select a file");
      return;
    }

    const formData = new FormData();

    formData.append("projectUpload", projectUpload);
    formData.append("userBatchName", userRole?.userBatchName);
    formData.append("name", userRole?.name);
    formData.append("phone", userRole?.phone);
    formData.append("submissionDate", projectsData?.submissionDate);
    formData.append("projectName", projectsData?.projectName);
    formData.append("courseName", userRole?.courseName);
    formData.append("email", userRole?.email);
    formData.append("githubLink", githubLink);
    formData.append("introduction", introduction);
    try {
      setLoading(true);

      const res = await UserService.createProjectUpload(formData);

      if (res.status === "Success") {
        toast.success("Project uploaded successfully");
        setProjectUpload(null);
        getByProjects();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("pId", data._id);
    formData.append("userBatchName", userRole?.userBatchName);
    formData.append("name", userRole?.name);
    formData.append("phone", userRole?.phone);
    formData.append("submissionDate", projectsData?.submissionDate);
    formData.append("projectName", projectsData?.projectName);
    formData.append("courseName", userRole?.courseName);
    formData.append("email", userRole?.email);
    formData.append("githubLink", githubLink);
    formData.append("introduction", introduction);

    if (projectUpload) {
      formData.append("projectUpload", projectUpload);
    }

    try {
      setLoading(true);

      const res = await UserService.updateProjects(formData);

      if (res.status === "Success") {
        toast.success("Project updated successfully");
        getByProjects();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Update failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <Header />
      </div>

      <div className="row">
        <div className="col-md-2 px-0">
          <Sidebar />
        </div>

        <div className="col-md-10 content-scroll content-bg mt-5 px-4">
          <div className="row">
            <div className="col-md-6">
              {/* Internship Progress */}
              <div className="card border-0 shadow-sm mb-4 rounded-4">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h5 className="fw-bold mb-1">{data?.courseName}</h5>
                      <small className="text-muted">
                        Summer Internship 2026 · Phase 4 of 4
                      </small>
                    </div>

                    <h2 className="text-warning fw-bold">
                      {percentageData?.percentage || 84}%
                    </h2>
                  </div>

                  <div className="progress mt-3" style={{ height: "8px" }}>
                    <div
                      className="progress-bar bg-warning"
                      style={{
                        width: `${percentageData?.percentage || 84}%`,
                      }}
                    ></div>
                  </div>

                  <div className="d-flex justify-content-between mt-2 small text-muted">
                    <span>Foundation</span>
                    <span>Live Sessions</span>
                    <span>Project Dev</span>
                    <span className="fw-bold text-warning">Submission</span>
                  </div>
                </div>
              </div>

              {/* Project Submission Card */}
              <div className="card border-0 shadow-sm rounded-4">
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h4 className="fw-bold">
                        Major Project: {projectsData?.projectName}
                      </h4>

                      <p className="text-muted mb-0">
                        Upload your report, add your GitHub link & introduction
                      </p>
                    </div>

                    <span className="badge bg-light text-dark border p-2">
                      Due:{" "}
                      {projectsData?.submissionDate
                        ? moment(projectsData.submissionDate).format(
                            "DD MMM YYYY"
                          )
                        : "-"}
                    </span>
                  </div>

                  {/* Github */}
                  <div className="mb-4">
                    <label className="form-label fw-bold">
                      GITHUB REPOSITORY *
                    </label>

                    <input
                      type="text"
                      className="form-control"
                      name="githubLink"
                      placeholder="https://github.com/username/project"
                      onChange={(e) => setGithubLink(e.target.value)}
                    />
                  </div>

                  {/* PDF Upload */}
                  <div className="mb-4">
                    <label className="form-label fw-bold">
                      PROJECT REPORT PDF *
                    </label>

                    <div
                      className="border rounded-4 p-5 text-center"
                      style={{
                        borderStyle: "dashed",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="file"
                        accept=".pdf"
                        className="form-control"
                        onChange={(e) =>
                          setProjectUpload(e.target.files?.[0] || null)
                        }
                      />

                      <p className="mt-3 mb-0">
                        Click to upload or drag & drop
                      </p>

                      <small className="text-muted">PDF only · max 20 MB</small>
                    </div>

                    {projectUpload && (
                      <div className="alert alert-success mt-3">
                        {projectUpload.name}
                      </div>
                    )}
                  </div>

                  {/* Introduction */}
                  <div className="mb-4">
                    <label className="form-label fw-bold">
                      PROJECT INTRODUCTION
                    </label>

                    <textarea
                      rows={5}
                      className="form-control"
                      placeholder="Briefly describe your project, tools used, key outcomes, approach..."
                      onChange={(e) => setIntroduction(e.target.value)}
                    />
                  </div>

                  {/* Resource Material */}
                  <div className="mb-4">
                    <label className="form-label fw-bold">
                      RESOURCE MATERIAL
                    </label>

                    <div className="border rounded-3 p-3 d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="mb-1">
                          {data?.courseName} Internship Project Guidelines
                        </h6>

                        <small className="text-muted">
                          PDF • Shared by Eduexpose
                        </small>
                      </div>

                      <button className="btn btn-outline-warning btn-sm">
                        View
                      </button>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="text-end">
                    <button
                      className="btn btn-light me-2"
                      onClick={() => {
                        setProjectUpload(null);
                      }}
                    >
                      Clear All
                    </button>

                    <button
                      className="btn btn-warning text-white"
                      disabled={loading}
                      onClick={data?._id ? handleEdit : handleSubmit}
                    >
                      {loading
                        ? data?._id
                          ? "Updating..."
                          : "Submitting..."
                        : data?._id
                        ? "Edit Project"
                        : "Submit Project"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card border-0 shadow-sm rounded-4">
                <div className="card-body p-4">
                  <h4 className="fw-bold mb-4">Submission Preview</h4>

                  <div className="mb-3">
                    <label className="fw-bold">Project Name</label>
                    <p>{projectsData?.projectName || "-"}</p>
                  </div>

                  <div className="mb-3">
                    <label className="fw-bold">Course Name</label>
                    <p>{userRole?.courseName?.[0] || "-"}</p>
                  </div>

                  <div className="mb-3">
                    <label className="fw-bold">Student Name</label>
                    <p>{userRole?.name || "-"}</p>
                  </div>

                  <div className="mb-3">
                    <label className="fw-bold">Email</label>
                    <p>{userRole?.email || "-"}</p>
                  </div>

                  <div className="mb-3">
                    <label className="fw-bold">Mobile Number</label>
                    <p>{userRole?.phone || "-"}</p>
                  </div>

                  <div className="mb-3">
                    <label className="fw-bold">Batch Name</label>
                    <p>{userRole?.userBatchName || "-"}</p>
                  </div>

                  <div className="mb-3">
                    <label className="fw-bold">GitHub Repository</label>
                    <p>
                      {data.githubLink ? (
                        <a
                          href={data.githubLink}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {data.githubLink}
                        </a>
                      ) : (
                        "-"
                      )}
                    </p>
                  </div>

                  <div className="mb-3">
                    <label className="fw-bold">Project Report</label>
                    {data?.projectUpload ? (
                      <p>
                        <a
                          href={data.projectUpload}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View PDF
                        </a>
                      </p>
                    ) : (
                      <p>No File Selected</p>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="fw-bold">Project Introduction</label>
                    <p>{data.introduction || "-"}</p>
                  </div>

                  <div className="mb-3">
                    <label className="fw-bold">Due Date</label>
                    <p>
                      {projectsData?.submissionDate
                        ? moment(projectsData.submissionDate).format(
                            "DD-MMM-YYYY"
                          )
                        : "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInternships;
